import { HttpClient } from '@angular/common/http';
import { EventEmitter, inject, Inject, Injectable } from '@angular/core';
import { AppConstants } from '../../constants/app.constants';
import { IndexStorageService } from './index-storage.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(
        private http: HttpClient,private storageService:IndexStorageService
  ) { 
    // get all values from session storage and set them to the class variables
    this.readFromSessionStorageUpdated();
    // try {
    // this.inputData=JSON.parse(window.sessionStorage.getItem('inputData')||'[]')
    // this.industryData=JSON.parse(window.sessionStorage.getItem('industryData')||'[]')
    // this.revenueData=JSON.parse(window.sessionStorage.getItem('revenueData')||'[]')
    // this.infringementData=JSON.parse(window.sessionStorage.getItem('infringementData')||'{}')
    // this.pasData=JSON.parse(window.sessionStorage.getItem('pasData')||'{}')
    // this.mainUploadData=JSON.parse(window.sessionStorage.getItem('mainUploadData')||'[]')
    // this.skipPas=window.sessionStorage.getItem('skipPas')=='true'?true:false
    // this.optimizedFlow=window.sessionStorage.getItem('optimizedFlow')=='true'?true:false
    // this.invalidityOnly=window.sessionStorage.getItem('invalidityOnly')=='true'?true:false
    // this.candidateWorkflowName=window.sessionStorage.getItem('candidateWorkflowName')||''
    // this.candidateProjectId=window.sessionStorage.getItem('candidateProjectId')||''
    // this.candidateProjectName=window.sessionStorage.getItem('candidateProjectName')||''
    // this.candidateWorkflowId=window.sessionStorage.getItem('candidateWorkflowId')||''
    // this.workflowProgressStatus=window.sessionStorage.getItem('workflowProgressStatus')||'todo'
    // this.stepsObject=JSON.parse(window.sessionStorage.getItem('stepsObject')||'{}')
    // this.totalSteps=JSON.parse(window.sessionStorage.getItem('totalSteps')||'[]')
    // this.inputFile=JSON.parse(window.sessionStorage.getItem('inputFile')||'null')
    // this.currentReportMode=window.sessionStorage.getItem('currentReportMode')||'-'
    // }
    // catch(e){
    //   console.log('error in parsing session storage', e)
    // }
  }

  inputFile:any=null;
  inputData:any=[]
  industryData:any=[]
  infringementData:any={}
  pasData:any={ }
  revenueData:any=[]
  skipPas=false
  tempData:any=[]
  mainUploadData=[]

  optimizedFlow=false;
  invalidityOnly=false;

  updateInputFile(file:any){
    this.inputFile=file;
    this.storageService.setItem('inputFile', JSON.stringify(this.inputFile))
    console.log('inputFile updated', this.inputFile)
  }

  clearInputFile(){
    this.inputFile=null;
    window.sessionStorage.removeItem('inputFile')
  }

  filterDataBasedOnInfringemnetSelection(){
    let tempIndustryData=[]
    let tempPasData=[]
    console.log('inputData', this.inputData)
    console.log('infringementData', this.infringementData)
    console.log('industryData', this.industryData)
    console.log('pasData', this.pasData)
    if(!this.infringementData.patentDetails || this.infringementData.patentDetails.length==0){
      console.log('no patent details found in infringement data')
      return;
    }
    this.infringementData.patentDetails.forEach((element:any) => {
      this.inputData.forEach((inputElement:any) => {
        if(element["Patent Number"]==inputElement["patentNumber"]){
          tempPasData.push(inputElement)
        }
      });
      this.industryData.forEach((industryElement:any) => {
        if(element["Company"]==industryElement["Company"]){
          tempIndustryData.push(industryElement)
        }
      });
    });
  }



  updateDataSameStructure(data:any, source:any=null, updateMainData=true){
    if(source=="pas"){
      this.pasData=data
      this.stepsObject['pas']=true
      this.workflowProgressStatus='inprogress'
    }
    if(source=="industry"){
      this.industryData=data
      this.stepsObject['target-scouting']=true
      this.workflowProgressStatus='inprogress'

    }
    if(source=="infringement"){
      this.infringementData=data
      this.filterDataBasedOnInfringemnetSelection()
      this.stepsObject['infringement']=true
    }
    if(source=="revenue"){
      this.industryData=data
      this.revenueData=data
      this.stepsObject['revenue']=true
    }
    this.syncWorkflow();
    if(updateMainData){
      console.log('updating main upload data', this.mainUploadData)
      this.inputData=data

      try{

        let candidate_workflowname:any=window.sessionStorage.getItem('candidateWorkflowName')||this.candidateWorkflowName
        let candidate_projectid:any=window.sessionStorage.getItem('candidateProjectId')||this.candidateProjectId
        let candidate_projectname:any=window.sessionStorage.getItem('candidateProjectName')||this.candidateProjectName
        window.sessionStorage.clear()
        this.storageService.setItem('inputData', JSON.stringify(this.inputData))
        this.storageService.setItem('mainUploadData', JSON.stringify(this.mainUploadData))
        this.storageService.setItem('candidateWorkflowName', candidate_workflowname.toString())
        this.storageService.setItem('candidateProjectId', candidate_projectid.toString())
        this.storageService.setItem('candidateProjectName', candidate_projectname.toString())
        this.storageService.setItem('optimizedFlow', this.optimizedFlow.toString())
        this.storageService.setItem('invalidityOnly', this.invalidityOnly.toString())
        this.storageService.setItem('skipPas', this.skipPas.toString())
        this.storageService.setItem('candidateWorkflowId', this.candidateWorkflowId.toString())
        this.storageService.setItem('workflowProgressStatus', this.workflowProgressStatus.toString())
        this.storageService.setItem('totalSteps', JSON.stringify(this.totalSteps))
        this.storageService.setItem('stepsObject', JSON.stringify(this.stepsObject))
        this.storageService.setItem('currentReportMode', this.currentReportMode.toString())
      }
      catch(e){
        console.log('error in updating session storage', e)
      }
    }
    else {
      this.writeToSessionStorageUpdated();
      
      // try{
      // this.storageService.setItem('inputData', JSON.stringify(this.inputData))
      // this.storageService.setItem('industryData', JSON.stringify(this.industryData))
      // this.storageService.setItem('infringementData', JSON.stringify(this.infringementData))
      // this.storageService.setItem('pasData', JSON.stringify(this.pasData))
      // this.storageService.setItem('revenueData', JSON.stringify(this.revenueData))
      // this.storageService.setItem('candidateWorkflowName', this.candidateWorkflowName.toString())
      // this.storageService.setItem('candidateProjectId', this.candidateProjectId.toString())
      // this.storageService.setItem('candidateProjectName', this.candidateProjectName.toString())
      // this.storageService.setItem('mainUploadData', JSON.stringify(this.mainUploadData))
      // this.storageService.setItem('optimizedFlow', this.optimizedFlow.toString())
      // this.storageService.setItem('invalidityOnly', this.invalidityOnly.toString())
      // this.storageService.setItem('skipPas', this.skipPas.toString())
      // this.storageService.setItem('candidateWorkflowId', this.candidateWorkflowId.toString())
      // this.storageService.setItem('workflowProgressStatus', this.workflowProgressStatus.toString())
      // this.storageService.setItem('stepsObject', JSON.stringify(this.stepsObject))
      // this.storageService.setItem('totalSteps', JSON.stringify(this.totalSteps))
      // this.storageService.setItem('currentReportMode', this.currentReportMode.toString())
      // }
      // catch(e){
      //   console.log('error in updating session storage', e)
      // }
    }

  }
  // create an observable that can be subscribed to and updated using a function
  routeObservable:any=new EventEmitter()
  updateRouteObservable(data:any){
    this.routeObservable.emit(data)
  }
  // basic step: upload, extraction
  // total steps in case of infringement: target scouting, infringement, revenue, summary
  // total steps in case of pas: pas, revenue
  onSkipPas(mode='copilot'){
    if(mode=='copilot')
    {
      this.optimizedFlow=true
    }
    else 
    {
      this.optimizedFlow=false
    }
    this.skipPas=true
    this.updateDataSameStructure([], 'industry', false)
    this.updateDataSameStructure({}, 'infringement', false)
    this.updateDataSameStructure([], 'revenue', false)
    this.emailSent=false;
    this.isReloadScenario=false;
    this.routeObservable.emit('target-scouting')
    this.currentReportMode='infringement'
    this.updateStepsObject('infringement')
  }
  onPasOnly(){
    this.invalidityOnly=true
    this.isReloadScenario=false;
    this.routeObservable.emit('pas')
    this.currentReportMode='pas'
    this.updateStepsObject('pas')
  }
  onClickNext(){
    this.routeObservable.emit('pas')
  }

  updateStepsObject(mode:any){
    if(mode=='infringement'){
    // add all steps to the steps object
    this.stepsObject['upload']=true
    this.stepsObject['extraction']=true
    this.stepsObject['target-scouting']=false
    this.stepsObject['infringement']=false
    this.stepsObject['revenue']=false
    this.stepsObject['summary']=false
    }
    else if(mode=='pas'){
      this.stepsObject['upload']=true
      this.stepsObject['extraction']=true
      this.stepsObject['pas']=false
    }
  }
  
  setMainUploadData(data:any){
    
    this.mainUploadData=data
    this.inputData=[]
    
    data.forEach((element:any) => {
      console.log('got data', data)
      console.log(this.inputData, this.tempData)
      this.inputData.push(
        {
          /*{ section['Title'] }}</td>
                <td>{{ section['Current Assignee'] }}</td>
                <td>{{ section['Priority Date'] }}</td>
                <td>{{ section['Expiration Date'] }}</td>
                <td class="claims-cell" (click)="openClaimsDialog(section['Claims'])">
                    {{ section['Claims'][0].slice(0, 15) }}...
                </td>
                <td>{{ section['Technology'] }}</td>
                <td>{{ section['Independent Claims'] }}</td>
                <td>{{ section['Dependent Claims'] }}</td>
                <td>{{ section['Patent Status'] }}*/
          patentNumber:element["Publication Number"],
          currentAssignee:element["Current Assignee"],
          priorityDate:element["Priority Date"],
          expirationDate:element["Expiration Date"],
          claims:element["Claims"],
          technology:element["Technology"],
          independentClaims:element["Independent Claims"],
          dependentClaims:element["Dependent Claims"],
          patentStatus:element["Patent Status"],
          publicationDate:element["Publication Date"],
          title:element["Title"]
          


        }
      )
    });
    this.storageService.setItem('mainUploadData', JSON.stringify(this.mainUploadData))
    this.storageService.setItem('inputData', JSON.stringify(this.inputData))
    this.stepsObject['upload']=true
    this.stepsObject['extraction']=true
    this.syncWorkflow();
  }
  onClickCancel(){
    this.routeObservable.emit('upload')
  }

  onClickGenerateReport(){
    this.routeObservable.emit('report')
  }

  usernameObservable:any=new EventEmitter()
  updateUsernameObservable(data:any){
    this.usernameObservable.emit(data)
  }
  getUsernameObservable(){
    let username=localStorage.getItem('username')
    if(username){
      this.usernameObservable.emit(username)
    return this.usernameObservable
  }
}

isUserAdmin(){
  // check in local storage if user is admi if the username is admin
  let username=localStorage.getItem('username')
  if(username=="admin"){
    return true
  }
  return false
}

get username(){
  return localStorage.getItem('username')
}

showLoginPopup=false

logOutObservable:any=new EventEmitter()

updateLogOutObservable(data:any){
  this.logOutObservable.emit(data)
}

completedReport={}

activeReport=''

selectedIndexForActiveReport=null;

hasPasReport=false
hasInfringementReport=false

hasPasReportObservable:any=new EventEmitter()
hasInfringementReportObservable:any=new EventEmitter()

updateHasPasReportObservable(data:any){
  console.log('updating has pas report observable', data)
  this.hasPasReport=data
  this.hasPasReportObservable.emit(data)
}

updateHasInfringementReportObservable(data:any){
  console.log('updating has infringement report observable', data)
  this.hasInfringementReport=data
  this.hasInfringementReportObservable.emit(data)
}

candidateWorkflowName=''
candidateProjectId=''
candidateProjectName=''
candidateWorkflowId=''
workflowProgressStatus='todo' // todo, inprogress, done, error
// default steps 
defaultSteps={
  infringement:[
    {name:'upload', completed: false},
    {name: 'extraction', completed: false},
    {name: 'target-scouting', completed: false},
    {name: 'infringement', completed: false},
    {name: 'revenue', completed: false},
    {name: 'summary', completed: false}
  ],
  pas:[
    {name:'upload', completed: false},
    {name: 'extraction', completed: false},
    {name: 'pas', completed: false},
  ]
}
totalSteps=[] // {name: 'step1', completed: false}
stepsObject:any={
  upload:false,
  extraction:false,
} // key: step, value true/false
currentReportMode='-' // pas, infrfingement

getStepsArray(){
  let stepsArray:any=[]
  Object.keys(this.stepsObject).forEach((key:any) => {
    stepsArray.push({name:key, completed:this.stepsObject[key]})
  })
  return stepsArray
}

resetData(){
  this.inputData=[]
  this.industryData=[]
  this.revenueData=[]
  this.infringementData={}
  this.pasData={}
  this.candidateWorkflowName=''
  this.candidateProjectId=''
  this.candidateProjectName=''
  this.candidateWorkflowId=''
  this.workflowProgressStatus='todo'
  this.stepsObject={
    upload:false,
    extraction:false,
  }
  this.totalSteps=[]
  this.currentReportMode='-'
  this.skipPas=false
  this.tempData=[]
  this.mainUploadData=[]
  this.inputFile=null;
  window.sessionStorage.clear()
}

isLoggedIn(){
  let sessionId=localStorage.getItem('sessionId')
  if(sessionId&&sessionId!='uninitialized'){
    return true 
  }
  return false
}

postLoginFunction:any=null;

oldSyncObject:any={}

syncWorkflow(callback:any=null){
  console.log('save report clicked')
  // alert('syncing workflow')
  let data:any={}
  let reportName:any=''
  reportName=this.candidateWorkflowName;
  // alert('Report Name: '+reportName)
  this.totalSteps=this.getStepsArray()
  if(reportName==null){
    return;
  }
  let projectId=this.candidateProjectId;  
  if(!projectId){
    return;
  }
  
  let reportAlreadySaved;
  // reportAlreadySaved=window.sessionStorage.getItem('reportAlreadySaved');
  // if(reportAlreadySaved=='true'){
  //   // this.loadingLink=false;
  //   return;
  // }
  data['patentData']=this.inputData;
  data['pasData']=this.pasData;
  data['industryData']=this.industryData;
  data['infringementData']=this.infringementData;
  data['workflowName']=reportName;
  data['workflowType']=this.currentReportMode;
  data['userId']=this.username;
  data['projectId']=projectId;
  data['totalSteps']=this.totalSteps;
  data['status']=this.workflowProgressStatus;

  console.log('reportDS', data)
  // POST /workflow 

  if(!this.candidateWorkflowId){

  this.post('/workflow', data).then((res:any)=>{
    // console.log(res);
    // this.reportId=res.workflowId;
    this.candidateWorkflowId=res.workflowId;
    // this.storageService.setItem('reportAlreadySaved', 'true');
    // this.storageService.setItem('reportId', this.reportId); 
    // this.fetchShareableLink();
    // this.shareCalled=true;
    callback(res);
    if(this.workflowProgressStatus=='done'){
      this.sendSuccessEmail();
    }
    else if(this.workflowProgressStatus=='error'){
      this.sendFailureEmail();
    }
  })
  .catch((err:any)=>{
    console.error('error in saving workflow', err);
    if(this.workflowProgressStatus=='done'){
      this.sendSuccessEmail();
    }
    else if(this.workflowProgressStatus=='error'){
      this.sendFailureEmail();
    }
    // alert('Error in saving workflow, please try again');
  });
}
else{
  data['workflowId']=this.candidateWorkflowId;
  console.log('oldSyncObject', this.oldSyncObject)
  // // remove the keys that are same in the old object and the new object
  // let tempOverallData=JSON.parse(JSON.stringify(data))
  // for (const key in data) {
  //   if (this.oldSyncObject.hasOwnProperty(key) && this.oldSyncObject[key] === data[key]) {
  //     delete data[key];
  //   }
  // }
  // // check if the object is empty
  // if (Object.keys(data).length === 0) {
  //   console.log('Object is empty');
  //   alert('No changes made to the workflow');
  //   return;
  // }
  
  // data['userId']=this.username;
  // data['projectId']=projectId;
  // data['totalSteps']=this.totalSteps;
  // data['workflowId']=this.candidateWorkflowId;
  // data['status']=this.workflowProgressStatus;
  this.put('/workflow', data).then((res:any)=>{
  console.log(res);
  if(callback)
  callback({...res, workflowId:this.candidateWorkflowId});
  if(this.workflowProgressStatus=='done'){
    this.sendSuccessEmail();
  }
  else if(this.workflowProgressStatus=='error'){
    this.sendFailureEmail();
  }
  // this.candidateWorkflowId=res.workflowId;
  // this.oldSyncObject=tempOverallData
  })
  .catch((err:any)=>{
    console.error('error in saving workflow', err);
    if(this.workflowProgressStatus=='done'){
      this.sendSuccessEmail();
    }
    else if(this.workflowProgressStatus=='error'){
      this.sendFailureEmail();
    }
    // alert('Error in saving workflow, please try again');
  });
}

}

handleWorkflowError(){
  this.workflowProgressStatus='error';
  this.syncWorkflow();
}


  serverUrl=AppConstants.SERVER_CONFIG.URL;

  put(url: string, body = <any>{}, { params = {}, headers = {} }: { params?: any, headers?: any } = {}): Promise<any> {
    return this.http
      .put(this.serverUrl + url, body, { params, headers })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

post(url: string, body = <any>{}, { params = {}, headers = {}, responseType }: { params?: any, headers?: any, responseType?: any } = {}): Promise<any> {
  console.log(this.serverUrl + url);
  return this.http
    .post(this.serverUrl + url, body, { params, headers, responseType })
    .toPromise()
    .then(this.extractData)
    .catch(this.handleError);
}
private extractData(res: any) {
  const body = res;
  return body || {};
}
handleError(error: any): Promise<any> {
  console.log('error in http service', error);
  // let status=error.status
  // if (error.status === 401||error.status==0) {
  //   // dataService.handleUserLogout();
  //   // alert('logout due to session expiry');
  //   this.onLogout()
  // }
  return Promise.reject(error);
}

updateUsingData(data:any){

  this.inputData = data.patentData;
  this.infringementData = data.infringementData;
  this.pasData = data.pasData;
  this.industryData = data.industryData;
  this.currentReportMode = data.workflowType.toLowerCase();
  this.activeReport=this.currentReportMode;
  this.candidateWorkflowName = data.workflowName;
  if(data.projectId)
  this.candidateProjectId = data.projectId;
  this.candidateWorkflowId = data.workflowId;
  this.totalSteps = data.totalSteps;
  // parse total steps into steps obect
  this.totalSteps.forEach((element:any) => {
    this.stepsObject[element.name]=element.completed
  });
  this.workflowProgressStatus = data.status;
  this.optimizedFlow=true;
  // parse main upload data using the input data
  this.mainUploadData = this.inputData.map((element:any) => {
    return {
      "Publication Number": element.patentNumber
      , "Current Assignee": element.currentAssignee
      , "Priority Date": element.priorityDate
      , "Expiration Date": element.expirationDate
      , "Claims": element.claims
      , "Technology": element.technology
      , "Independent Claims": element.independentClaims
      , "Dependent Claims": element.dependentClaims
      , "Patent Status": element.patentStatus
      , "Publication Date": element.publicationDate
      , "Title": element.title
    }
  }
  );

  if (this.currentReportMode == 'infringement') {
    this.skipPas = true;
  } else {
    this.skipPas = false;
  }

  this.writeToSessionStorageUpdated();

}

userEmail='namansuman01@gmail.com'
emailSent=false

sendSuccessEmail(){
  if(this.emailSent) return; // prevent multiple emails
  this.emailSent=true;
  /*{"recipient_email": "namansuman01@gmail.com",
  "user_name": "Naman",
  "workflow_type": "infringement_detector",
  "project_name": "project_test_1",
  "report_name": "test_Report",
  "is_success": false,
  "retry_url": "https://yourdomain.com/reports/retry/12345"
}*/
  let data={
    recipient_email:localStorage.getItem('email')||this.userEmail,
    user_name:localStorage.getItem('username')||'',
    workflow_type:this.currentReportMode=='Pas'?'Invalidity Check':'Infringe Fusion',
    project_name:this.candidateProjectName,
    report_name:this.candidateWorkflowName,
    is_success:true,
    view_report_url:`${window.location.origin}/app/report?reportId=${this.candidateWorkflowId}&projectId=${this.candidateProjectId}`
  }
  this.post('/notification/send-email', data).then((res:any)=>{
    console.log('success email sent', res)
  }).catch((err:any)=>{
    console.error('error in sending success email', err)
  })
}

sendFailureEmail(){
  if(this.emailSent) return; // prevent multiple emails
  this.emailSent=true;
  let data={
    recipient_email:localStorage.getItem('email')||this.userEmail,
    user_name:localStorage.getItem('username')||'',
    workflow_type:this.currentReportMode=='Pas'?'Invalidity Check':'Infringe Fusion',
    project_name:this.candidateProjectName,
    report_name:this.candidateWorkflowName,
    is_success:false,
    retry_url:`${window.location.origin}/app/projects/${this.candidateProjectId}/reports`
  }
  this.post('/notification/send-email', data).then((res:any)=>{
    console.log('failure email sent', res)
  }).catch((err:any)=>{
    console.error('error in sending failure email', err)
  })
}

postFullURL(url: string, body = <any>{}, { params = {}, headers = {}, responseType }: { params?: any, headers?: any, responseType?: any } = {}): Promise<any> {
  console.log(url);
  return this.http
    .post(url, body, { params, headers, responseType })
    .toPromise()
    .then(this.extractData)
    .catch(this.handleError);
}

get(url: string, { params = {}, headers = {}, responseType }: { params?: any, headers?: any, responseType?: any } = {}): Promise<any> {
  return this.http
    .get(this.serverUrl + url, { params, headers, responseType })
    .toPromise()
    .then(this.extractData)
    .catch(this.handleError);
}

// have an additional variable named isStorageFull to check if the session storage is full
isStorageFull=false;
isReloadScenario=false;
// update write function to not write inputData, industryData, infringementData, pasData, revenueData, mainUploadData if isStorageFull is true
// rewrite write function to reduce redundancy from the whole file 

writeToSessionStorageUpdated(){

  // first write all the data that is to be written anyway
  this.storageService.setItem('candidateWorkflowName', this.candidateWorkflowName.toString())
  this.storageService.setItem('candidateProjectId', this.candidateProjectId.toString())
  this.storageService.setItem('candidateProjectName', this.candidateProjectName.toString())
  this.storageService.setItem('candidateWorkflowId', this.candidateWorkflowId.toString())
  this.storageService.setItem('workflowProgressStatus', this.workflowProgressStatus.toString())
  this.storageService.setItem('stepsObject', JSON.stringify(this.stepsObject))
  this.storageService.setItem('totalSteps', JSON.stringify(this.totalSteps))
  this.storageService.setItem('currentReportMode', this.currentReportMode.toString())
  this.storageService.setItem('optimizedFlow', this.optimizedFlow.toString())
  this.storageService.setItem('invalidityOnly', this.invalidityOnly.toString())
  this.storageService.setItem('skipPas', this.skipPas.toString())
  this.storageService.setItem('inputFile', JSON.stringify(this.inputFile))
  this.storageService.setItem('storageFull', this.isStorageFull.toString())
  this.storageService.setItem('mainUploadData', JSON.stringify(this.mainUploadData))
  // now check if isStorageFull is true
  if(this.isStorageFull){
    console.log('session storage is full, not writing inputData, industryData, infringementData, pasData, revenueData, mainUploadData')
    return;
  }

  try{

    // if isStorageFull is false, write the data
    this.storageService.setItem('inputData', JSON.stringify(this.inputData))
    this.storageService.setItem('industryData', JSON.stringify(this.industryData))
    this.storageService.setItem('infringementData', JSON.stringify(this.infringementData))
    this.storageService.setItem('pasData', JSON.stringify(this.pasData))
    this.storageService.setItem('revenueData', JSON.stringify(this.revenueData))
    console.log('session storage updated successfully')
    this.isStorageFull=false; // reset the isStorageFull variable to false after writing the data
  }
  catch(e){
    console.log('error in writing to session storage', e)
    this.isStorageFull=true; // set the isStorageFull variable to true if there is an error in writing to session storage
  }
  
}

readFromSessionStorageUpdated(){
  // read all the data that is to be read anyway
  this.candidateWorkflowName=window.sessionStorage.getItem('candidateWorkflowName')||''
  this.candidateProjectId=window.sessionStorage.getItem('candidateProjectId')||''
  this.candidateProjectName=window.sessionStorage.getItem('candidateProjectName')||''
  this.candidateWorkflowId=window.sessionStorage.getItem('candidateWorkflowId')||''
  this.workflowProgressStatus=window.sessionStorage.getItem('workflowProgressStatus')||'todo'
  this.stepsObject=JSON.parse(window.sessionStorage.getItem('stepsObject')||'{}')
  this.totalSteps=JSON.parse(window.sessionStorage.getItem('totalSteps')||'[]')
  this.currentReportMode=window.sessionStorage.getItem('currentReportMode')||'-'
  this.optimizedFlow=window.sessionStorage.getItem('optimizedFlow')=='true'?true:false
  this.invalidityOnly=window.sessionStorage.getItem('invalidityOnly')=='true'?true:false
  this.skipPas=window.sessionStorage.getItem('skipPas')=='true'?true:false
  this.isStorageFull=window.sessionStorage.getItem('storageFull')=='true'?true:false
  // now check if isStorageFull is true
  if(this.isStorageFull){
    console.log('session storage is full, not reading inputData, industryData, infringementData, pasData, revenueData, mainUploadData')
    this.inputData=[]
    this.industryData=[]
    this.infringementData={}
    this.pasData={}
    this.revenueData=[]
    this.mainUploadData=[]
    this.inputFile=null;
    return;
  }
  // if isStorageFull is false, read the data
  try{
    this.inputData=JSON.parse(window.sessionStorage.getItem('inputData')||'[]')
    this.industryData=JSON.parse(window.sessionStorage.getItem('industryData')||'[]')
    this.revenueData=JSON.parse(window.sessionStorage.getItem('revenueData')||'[]')
    this.infringementData=JSON.parse(window.sessionStorage.getItem('infringementData')||'{}')
    this.pasData=JSON.parse(window.sessionStorage.getItem('pasData')||'{}')
    this.mainUploadData=JSON.parse(window.sessionStorage.getItem('mainUploadData')||'[]')
    this.inputFile=JSON.parse(window.sessionStorage.getItem('inputFile')||'null')
  }
  catch(e){
    console.log('error in reading from session storage', e)
  }
}





writeToSessionStorage(){  
  this.storageService.setItem('inputData', JSON.stringify(this.inputData))
  this.storageService.setItem('industryData', JSON.stringify(this.industryData))
  this.storageService.setItem('infringementData', JSON.stringify(this.infringementData))
  this.storageService.setItem('pasData', JSON.stringify(this.pasData))
  this.storageService.setItem('revenueData', JSON.stringify(this.revenueData))
  this.storageService.setItem('candidateWorkflowName', this.candidateWorkflowName.toString())
  this.storageService.setItem('candidateProjectId', this.candidateProjectId.toString())
  this.storageService.setItem('candidateProjectName', this.candidateProjectName.toString())
  this.storageService.setItem('mainUploadData', JSON.stringify(this.mainUploadData))
  this.storageService.setItem('optimizedFlow', this.optimizedFlow.toString())
  this.storageService.setItem('invalidityOnly', this.invalidityOnly.toString())
  this.storageService.setItem('skipPas', this.skipPas.toString())
  this.storageService.setItem('candidateWorkflowId', this.candidateWorkflowId.toString())
  this.storageService.setItem('workflowProgressStatus', this.workflowProgressStatus.toString())
  this.storageService.setItem('stepsObject', JSON.stringify(this.stepsObject))
  this.storageService.setItem('totalSteps', JSON.stringify(this.totalSteps))
  this.storageService.setItem('currentReportMode', this.currentReportMode.toString())
  this.storageService.setItem('inputFile', JSON.stringify(this.inputFile))
}
readFromSessionStorage(){ 
  try {
  this.inputData=JSON.parse(window.sessionStorage.getItem('inputData')||'[]')
  this.industryData=JSON.parse(window.sessionStorage.getItem('industryData')||'[]')
  this.revenueData=JSON.parse(window.sessionStorage.getItem('revenueData')||'[]')
  this.infringementData=JSON.parse(window.sessionStorage.getItem('infringementData')||'{}')
  this.pasData=JSON.parse(window.sessionStorage.getItem('pasData')||'{}')
  this.mainUploadData=JSON.parse(window.sessionStorage.getItem('mainUploadData')||'[]')
  this.skipPas=window.sessionStorage.getItem('skipPas')=='true'?true:false
  this.optimizedFlow=window.sessionStorage.getItem('optimizedFlow')=='true'?true:false
  this.invalidityOnly=window.sessionStorage.getItem('invalidityOnly')=='true'?true:false
  this.candidateWorkflowName=window.sessionStorage.getItem('candidateWorkflowName')||''
  this.candidateProjectId=window.sessionStorage.getItem('candidateProjectId')||''
  this.candidateProjectName=window.sessionStorage.getItem('candidateProjectName')||''
  this.candidateWorkflowId=window.sessionStorage.getItem('candidateWorkflowId')||''
  this.workflowProgressStatus=window.sessionStorage.getItem('workflowProgressStatus')||'todo'
  this.stepsObject=JSON.parse(window.sessionStorage.getItem('stepsObject')||'{}')
  this.totalSteps=JSON.parse(window.sessionStorage.getItem('totalSteps')||'[]')
  this.currentReportMode=window.sessionStorage.getItem('currentReportMode')||'-'
  this.inputFile=JSON.parse(window.sessionStorage.getItem('inputFile')||'null')
  }
  catch(e){
    console.log('error in parsing session storage', e)
  }
}

getWorkflowDataAndUpdateValues(updateReloadScenario=true){
  return this.get(`/workflows/${this.candidateProjectId}/${this.candidateWorkflowId}?userId=${this.username}`)
    .then((res:any)=>{
      console.log('workflow data received', res);
      this.updateUsingData(res);
      if(updateReloadScenario){
      this.isReloadScenario=false;
      }
      this.writeToSessionStorageUpdated();
      return res;
    })
    .catch((err:any)=>{
      console.error('error in getting workflow data', err);
      throw err;
    });

}
}
